// 函數說明
// 傳入的data為物件陣列[{}, {}, {}]，每一個物件為一筆資料
// 比對物件的所有屬性值(或給定要比對的屬性群組陣列)
// 只要有任何一個屬性值內含比對值，即符合
// 傳回所有符合的資料物件陣列
// 區分大小寫

// 變數定義
// searchStrs = 搜尋strings陣列 例: ['abc', 'def']
// orinData = 資料物件陣列 例: [{a: 'abc', b: '123', ...}, {a: 'air', b: 'jag', ...}]
// keysToSearch = 指定搜尋資料物件的特定keys陣列 例: ['a', 'b']
// returnType = 傳回內容類型，預設為傳回obj陣列，1為傳回索引陣列，
// 2為傳回obj以及索引陣列 例: {obj: resultObj, ind: resultInd}
// comparingMode = 1為完全符合 or 0為包含即可 預設為包含即可

// 不列入搜尋結果的項目可加上'exception' key，值為true時不列入
// 主要用途在刪除項目時不變動原始data，且search時也不出現
// 以避免重新排序需求

// 效能優化memo

// 若要不區分大小寫，應先在一開始將資料全轉小寫，再進行比對
// 一筆資料轉1次即可，避免每次loop重複進行轉小寫動作

// 當有多組搜尋文字時，資料先轉文字，
// 避免同1筆資料在不同搜尋文字比對時重複做轉文字動作

// 寫orinData轉小寫lib和轉文字lib，import進來，再新增option看是否執行

// ============

export default function (searchStrs, orinData, keysToSearch, returnType, comparingMode) {
  const dataLen = orinData.length,
    keysLen = keysToSearch ? keysToSearch.length : 0,
    seaStrsLen = searchStrs.length;

  // 不區分大小寫情況下效能優化 ====
  let processedSearchStrs, processedData;
  // 有比對多次的需求時才需要把處理結果暫存起來

  // 搜尋字串先轉文字型態並轉小寫暫存
  processedSearchStrs = searchStrs.map((item, ind) => {
    return item.toString().toLowerCase();
  });


  if (keysLen) {
    // 只需要轉有需要比對的屬性
    processedData = orinData.map((obj, ind) => {
      // 建立複本，不修改原物件
      const newObj = {};

      // 逐key轉文字型態並轉小寫
      keysToSearch.forEach((key, ind) => {
        newObj[key] = obj[key] && obj[key].toString().toLowerCase();
      });

      return newObj
    });
  } else {
    // 全轉
    processedData = orinData.map((obj, ind) => {
      // 建立複本，不修改原物件
      const keys = Object.keys(obj),
        newObj = {};

      // 逐key轉小寫
      keys.forEach((key, ind) => {
        newObj[key] = obj[key] && obj[key].toString().toLowerCase();
      });

      return newObj
    });

  }

  // ================


  // search 功能重效能，以程式碼換取效能

  let resultObj = [], resultInd = [];

  switch (returnType) {
    case 1:

      if (seaStrsLen !== 0) {

        if (comparingMode) {
          for (let i = 0; i < dataLen; i++) {

            let exit = 0;
            // 有指定比對keys就不需要確認hasOwnProperty
            if (keysLen) {
              for (let j = 0; j < keysLen; j++) {
                if (exit) break;
                let propName = keysToSearch[j];

                if (processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName] === processedSearchStrs[k]) {
                      if (!processedData[i]['exception']) resultInd.push(i);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            } else {
              for (let propName in processedData[i]) {
                if (exit) break;
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName] === processedSearchStrs[k]) {
                      if (!processedData[i]['exception']) resultInd.push(i);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            }
          }
        } else {
          for (let i = 0; i < dataLen; i++) {

            let exit = 0;
            // 有指定比對keys就不需要確認hasOwnProperty
            if (keysLen) {
              for (let j = 0; j < keysLen; j++) {
                if (exit) break;
                let propName = keysToSearch[j];
                if (processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName].indexOf(processedSearchStrs[k]) !== -1) {
                      if (!processedData[i]['exception']) resultInd.push(i);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            } else {
              for (let propName in processedData[i]) {
                if (exit) break;
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName].indexOf(processedSearchStrs[k]) !== -1) {
                      if (!processedData[i]['exception']) resultInd.push(i);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }

      return resultInd;

    case 2:

      if (seaStrsLen !== 0) {

        if (comparingMode) {
          for (let i = 0; i < dataLen; i++) {

            let exit = 0;

            if (keysLen) {
              for (let j = 0; j < keysLen; j++) {
                if (exit) break;
                let propName = keysToSearch[j];
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName] === processedSearchStrs[k]) {
                      if (!processedData[i]['exception']) {
                        resultObj.push(orinData[i]);
                        resultInd.push(i);
                      }
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            } else {
              for (let propName in processedData[i]) {
                if (exit) break;
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName] === processedSearchStrs[k]) {
                      if (!processedData[i]['exception']) {
                        resultObj.push(orinData[i]);
                        resultInd.push(i);
                      }
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            }
          }
        } else {
          for (let i = 0; i < dataLen; i++) {

            let exit = 0;

            if (keysLen) {
              for (let j = 0; j < keysLen; j++) {
                if (exit) break;
                let propName = keysToSearch[j];
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName].indexOf(processedSearchStrs[k]) !== -1) {
                      if (!processedData[i]['exception']) {
                        resultObj.push(orinData[i]);
                        resultInd.push(i);
                      }
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            } else {
              for (let propName in processedData[i]) {
                if (exit) break;
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName].indexOf(processedSearchStrs[k]) !== -1) {
                      if (!processedData[i]['exception']) {
                        resultObj.push(orinData[i]);
                        resultInd.push(i);
                      }
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }

      return { obj: resultObj, ind: resultInd };

    default:

      if (seaStrsLen !== 0) {

        if (comparingMode) {
          for (let i = 0; i < dataLen; i++) {

            let exit = 0;

            if (keysLen) {
              for (let j = 0; j < keysLen; j++) {
                if (exit) break;
                let propName = keysToSearch[j];
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName] === processedSearchStrs[k]) {
                      if (!processedData[i]['exception']) resultObj.push(orinData[i]);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            } else {
              for (let propName in processedData[i]) {
                if (exit) break;
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName] === processedSearchStrs[k]) {
                      if (!processedData[i]['exception']) resultObj.push(orinData[i]);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            }
          }
        } else {
          for (let i = 0; i < dataLen; i++) {

            let exit = 0;

            if (keysLen) {
              for (let j = 0; j < keysLen; j++) {
                if (exit) break;
                let propName = keysToSearch[j];
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName].indexOf(processedSearchStrs[k]) !== -1) {
                      if (!processedData[i]['exception']) resultObj.push(orinData[i]);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            } else {
              for (let propName in processedData[i]) {
                if (exit) break;
                if (processedData[i].hasOwnProperty(propName) && processedData[i][propName]) {
                  for (let k = 0; k < seaStrsLen; k++) {
                    if (processedData[i][propName].indexOf(processedSearchStrs[k]) !== -1) {
                      if (!processedData[i]['exception']) resultObj.push(orinData[i]);
                      exit = 1;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }

      return resultObj;

  }

}


// WEBPACK FOOTER //
// ./src/commonJS/searchContent.js